var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlaye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04161 3.32439C4.51412 3.89132 4.21094 4.76389 4.21094 5.89774V46.2283C4.21094 47.3621 4.51412 48.2347 5.06132 48.7819L5.20429 48.9027L27.8024 26.3046V25.7968L5.18457 3.20361L5.04161 3.32439Z",
    fill: "url(#paint0_linear_11017_9963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3189 33.8665L27.7812 26.3264V25.7989L35.3213 18.2588L35.484 18.3599L44.402 23.4277C46.9556 24.8672 46.9556 27.2384 44.402 28.6976L35.484 33.7654C35.4816 33.7654 35.3189 33.8665 35.3189 33.8665Z",
    fill: "url(#paint1_linear_11017_9963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4805 33.7663L27.7801 26.0635L5.03906 48.8046C5.86973 49.6968 7.26732 49.7979 8.83006 48.9253L35.4805 33.7663Z",
    fill: "url(#paint2_linear_11017_9963)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4805 18.3626L8.83006 3.22321C7.26979 2.33092 5.86973 2.4517 5.03906 3.34399L27.7777 26.0629L35.4805 18.3626Z",
    fill: "url(#paint3_linear_11017_9963)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3215 33.6035L8.8535 48.6418C7.37457 49.4922 6.05585 49.433 5.20546 48.6615L5.0625 48.8045L5.20546 48.9253C6.05585 49.6943 7.37457 49.7559 8.8535 48.9056L35.5039 33.7662L35.3215 33.6035Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3973 28.4347L35.2969 33.6036L35.4596 33.7663L44.3775 28.6984C45.6543 27.9688 46.2829 27.0174 46.2829 26.0635C46.2016 26.936 45.5533 27.7667 44.3973 28.4347Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83261 3.48721L44.401 23.6944C45.557 24.3426 46.2053 25.193 46.3063 26.0656C46.3063 25.1142 45.6778 24.1602 44.401 23.4306L8.83261 3.22346C6.27898 1.76425 4.21094 2.97944 4.21094 5.89787V6.16161C4.21094 3.24318 6.27898 2.04771 8.83261 3.48721Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11017_9963",
    x1: 25.7732,
    y1: 5.46434,
    x2: -10.425,
    y2: 15.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11017_9963",
    x1: 47.725,
    y1: 26.0637,
    x2: 3.58885,
    y2: 26.0637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11017_9963",
    x1: 31.293,
    y1: 30.2538,
    x2: 2.23315,
    y2: 79.1639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11017_9963",
    x1: -0.685547,
    y1: -10.0915,
    x2: 12.2792,
    y2: 11.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaye);
export default __webpack_public_path__ + "static/media/google-playe.dcb312552e67c63e25c584a9a51d0746.svg";
export { ForwardRef as ReactComponent };